import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'shared/components/table/DataTable';
import { modelMap } from 'shared/utils';
import { FILTER_DISPLAY_TYPE, VOUCHER_TYPES } from 'shared/constants';
import { searchVoucherBatches } from 'shared/api/vouchers';
import { FilterRedirect } from 'shared/hoc/withFilters';
import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import { TextEditor } from 'shared/components/data-display/editors';

const columns = [
  {
    name: 'Batch',
    orderBy: 'id',
    formatter: (row) => <Link to={`/voucher/batch/${row.batchId}`}>{row.batchId}</Link>,
  },
  {
    name: 'Type',
    formatter: (row) => VOUCHER_TYPES[row.voucherType].label,
  },
  {
    name: 'Service',
    jsonKey: 'productName',
    orderBy: 'iiq_speed',
  },
  {
    name: 'Duration',
    jsonKey: 'duration',
    orderBy: 'duration_in_months',
  },
  {
    name: 'Valid For',
    formatter: (row) => {
      const model = modelMap[row.ruleType];
      const modelId = row[model.idKey];
      const modelName = row[model.nameKey];
      return <Link to={model.getView(modelId)}>{modelName}</Link>;
    },
  },
  {
    name: 'Code Usage',
    formatter: (row) => `${row.redeemed} / ${row.total}`,
  },
  {
    name: 'Created By',
    jsonKey: 'createdBy',
    orderBy: 'created_by',
  },
  {
    name: 'Created At',
    orderBy: 'created_at',
    formatter: (row) => new Date(row.createdAt).toLocaleDateString(),
  },
];

const validForOptions = ['property', 'complex']
  .map((key) => ({
    label: modelMap[key].title,
    value: key,
  }));

const voucherTypeOptions = Object
  .keys(VOUCHER_TYPES)
  .map((key) => ({
    label: VOUCHER_TYPES[key].label,
    value: key,
  }));

const usageOptions = [
  {
    label: 'Every voucher used',
    value: 'every',
  },
  {
    label: 'Some vouchers used',
    value: 'some',
  },
  {
    label: 'No vouchers used',
    value: 'none',
  },
];

const filters = [
  {
    label: 'Code Usage',
    param: 'code_usage',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: usageOptions,
    }),
  },
  {
    label: 'Valid For',
    param: 'rule_type',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: validForOptions,
    }),
  },
  {
    label: 'Voucher Type',
    param: 'voucher_type',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      options: voucherTypeOptions,
    }),
  },
  {
    label: 'Search by voucher',
    param: 'voucher',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: TextEditor,
  },
];

/**
 * @param {Object} props
 * @param {string} props.filterKey
 * @param {string} props.savedFilters
 * @param {string} props.path
 */
export default function VoucherBatchSearch({
  filterKey,
  savedFilters,
  path,
}) {
  if (!FilterRedirect(path, savedFilters)) {
    return (
      <DataTable
        columns={columns}
        filters={filters}
        filterKey={filterKey}
        searchRequest={searchVoucherBatches}
        rowId="batchId"
        tableName="Voucher Batches"
        className="table-height-large"
      />
    );
  }
}
